<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="盘号">
          <a-select
            showSearch
            allowClear
            :filterOption="filterOption"
            placeholder="请选择盘号"
            v-decorator="[ 'appSsid', validatorRules.appSsid]">
            <a-select-option v-for="item in appList" :value="item.appssid" :key="item.appssid">{{ item.appName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="引流渠道">
          <a-input placeholder="引流渠道，0=不限" :maxLength="32" v-decorator="[ 'channel', validatorRules.channel]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="强制放款渠道">
          <a-select
            allowClear
            placeholder="请选择强制放款渠道"
            v-decorator="[ 'payChannel', validatorRules.payChannel]">
            <a-select-option v-for="item in payChannelList" :value="item.value" :key="item.key">{{ item.label || item.value }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="允许放款总数">
          <a-input-number :min="0" v-decorator="[ 'allowTotal', validatorRules.allowTotal]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否允许放款">
          <a-select v-decorator="[ 'allowStatus', validatorRules.allowStatus]">
            <a-select-option :value="1">允许</a-select-option>
            <a-select-option :value="0">不允许</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="状态">
          <a-select v-decorator="[ 'status', validatorRules.status]" :disabled="isGlobalRow">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addPayoutCtrl, editPayoutCtrl, getPayoutChannelSelect } from '@/webpublicapi/third'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'

export default {
  name: 'PayoutCtrlModal',
  data () {
    return {
      title: '操作',
      visible: false,
      model: {},
      // (0,0,0) 全局兜底行：状态恒为启用，不允许编辑
      isGlobalRow: false,
      appList: [],
      payChannelList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        appSsid: { rules: [{ required: true, message: '请选择盘号!' }] },
        channel: { rules: [{ required: true, message: '请输入引流渠道!' }] },
        payChannel: { rules: [{ required: true, message: '请选择强制放款渠道!' }] },
        allowTotal: { initialValue: 0 },
        allowStatus: { rules: [{ required: true, message: '请选择是否允许放款!' }], initialValue: 1 },
        status: { rules: [{ required: true, message: '请选择状态!' }], initialValue: 1 }
      }
    }
  },
  created () {
    this.loadAppList()
    this.loadPayChannelList()
  },
  methods: {
    loadAppList () {
      getApplistExcludingSubApp().then(res => {
        if (res.code === 1000) {
          // 过滤"全部"空值项，前插 '0' 兜底项（'0' 为全盘号兜底配置）
          this.appList = [{ appssid: '0', appName: '0-全部盘号' }]
            .concat((res.data || []).filter(item => item.appssid !== ''))
        }
      })
    },
    loadPayChannelList () {
      getPayoutChannelSelect().then(res => {
        if (res.code === 1000) {
          // 前插 '0' 兜底项（'0' 为不限强制放款渠道）
          this.payChannelList = [{ key: '0', value: '0', label: '0-不限' }].concat(res.data || [])
        }
      })
    },
    filterOption (inputValue, option) {
      return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
    },
    add () {
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.isGlobalRow = this.model.appSsid === '0' && this.model.channel === '0' && this.model.payChannel === '0'
      // 全局行状态强制回填启用，提交时也恒为 1
      if (this.isGlobalRow) {
        this.model.status = 1
      }
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'appSsid', 'channel', 'payChannel', 'allowTotal', 'allowStatus', 'status'))
      })
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.channel = (values.channel || '').trim()
          values.allowTotal = values.allowTotal || 0
          const formData = Object.assign(this.model, values)
          let obj
          if (!this.model.id) {
            obj = addPayoutCtrl(formData)
          } else {
            obj = editPayoutCtrl(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
